import { ReactNode } from 'react';
import { DEFAULT_EMPTY_MESSAGE } from '../constants';

interface ITableEmptyRowProps {
  /** Number of columns the message spans — pass the length of the rendered header columns */
  columnsCount: number,
  /** Test identifier of the owning table; the cell is exposed as `{dataTest}EmptyMessage` */
  dataTest: string,
  /** Hides the message while a request is in flight, so it cannot show through a loading overlay */
  isFetching?: boolean,
  /** Message or node rendered when the collection is empty */
  message?: ReactNode,
  /** Additional CSS class for the cell */
  className?: string,
}

const TableEmptyRow = ({
  columnsCount,
  dataTest,
  isFetching = false,
  message = DEFAULT_EMPTY_MESSAGE,
  className,
}: ITableEmptyRowProps) => (
  <tr>
    <td
      colSpan={ columnsCount }
      className={ className }
      data-test={ `${ dataTest }EmptyMessage` }
    >
      { isFetching ? '' : message }
    </td>
  </tr>
);

export default TableEmptyRow;
